export default "__VITE_ASSET__DZjoSln1__"